import React from "react";
import loadinggif from "./Asset/Loading.gif";

const Loader=()=>{
    
    return (
        <div class="overlay1">
    <div class="overlay__inner1">
        <div class="overlay__content1">
            <img class="overlay__content1 img" src={loadinggif} alt="loaderlogo"/>
        </div>
    </div>
</div>
    )
}
export default Loader